// extracted by mini-css-extract-plugin
export default {"busOption":"Bus_busOption__y-Yxx","busInfo":"Bus_busInfo__hwfxb","busPrice":"Bus_busPrice__jBjf7"};